<template>
    <div class="goods-box">
        <div class="wrapper">
            <draggable
                    class="dragArea list-group"
                    :list="configData.list"
                    group="peoples">
                <div class="item" v-for="(goods,index) in configData.list" :key="index + ''"
                     v-if="configData.list.length">
                    <img :src="goods.image" alt="">
                    <span class="iconfont icondel_1" @click.stop="bindDelete(index)"></span>
                </div>
                <div class="add-item item" @click="changeGoods"><span class="iconfont-diy iconaddto"></span></div>
            </draggable>
        </div>
        <Modal v-model="modals" title="商品列表" footerHide  class="paymentFooter" scrollable width="900" @on-cancel="cancel">
            <goods-list ref="goodslist" :ischeckbox="true" @getProductId="getProductId"></goods-list>
        </Modal>
    </div>
</template>

<script>
    import draggable from 'vuedraggable'
    import goodsList from '@/components/goodsList/index';

    export default {
        name: "cgoods",
        components: {
            draggable,
            goodsList
        },
        props: {
            configData: {
                type: Object,
                default: {}
            },
        },
        data () {
            return {
                modals: false,
            }
        },
        methods: {
            unique(arr) {
                const res = new Map();
                return arr.filter((arr) => !res.has(arr.product_id) && res.set(arr.product_id, 1))
            },
            // 选择商品
            changeGoods () {
                this.modals = true;
                this.$refs.goodslist.getList();
                this.$refs.goodslist.goodsCategory();
            },
            getProductId: function (data) {
                this.modals = false;
                let list = this.configData.list.concat(data);
                this.configData.list = this.unique(list);
            },
            cancel: function () {
                this.modals = false
            },
            bindDelete (index) {
                this.configData.list.splice(index, 1)
            }
        }
    }
</script>

<style scoped lang="less">
    .goods-box {
        padding: 16px 0;
        margin-bottom: 16px;
        border-top: 1px solid rgba(0, 0, 0, 0.05);

        .wrapper, .list-group {
            display: flex;
            flex-wrap: wrap;
        }

        .add-item {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 80px;
            height: 80px;
            margin-bottom: 10px;
            background: #F7F7F7;

            .iconfont-diy {
                font-size: 20px;
                color: #D8D8D8;
            }
        }

        .item {
            position: relative;
            width: 80px;
            height: 80px;
            margin-bottom: 20px;
            margin-right: 12px;

            img {
                width: 100%;
                height: 100%;
            }

            .icondel_1 {
                position: absolute;
                right: -10px;
                top: -16px;
                color: #999999;
                font-size: 28px;
                cursor: pointer;
            }
        }

    }
</style>
